//frontend/src/MainLayout.jsx

import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import { IoMdChatbubbles } from 'react-icons/io';
import { toast } from 'react-toastify';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import ChatBot from '../ChatBot/ChatBot';
import { useAuth } from '../../context/AuthContext';

const MainLayout = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
    const [sidebarMobileOpen, setSidebarMobileOpen] = useState(false);
    const [showChatBot, setShowChatBot] = useState(false);

    // Pages qui ne doivent pas afficher le sidebar même si l'utilisateur est connecté
    const pagesWithoutSidebar = ['/', '/login', '/register', '/forgot-password', '/verify-email', '/resend-verification'];
    const shouldShowSidebar = isAuthenticated && !pagesWithoutSidebar.includes(location.pathname);

    const handleChatBotOpen = () => {
        setShowChatBot(true);
        toast.info('💬 Assistant IA à votre service !');
    };

    return (
        <>
            <Navbar
                onSidebarToggle={() => setSidebarMobileOpen(prev => !prev)}
            />
            {shouldShowSidebar && (
                <Sidebar
                    collapsed={sidebarCollapsed}
                    setCollapsed={setSidebarCollapsed}
                    mobileOpen={sidebarMobileOpen}
                    setMobileOpen={setSidebarMobileOpen}
                />
            )}
            <div className={shouldShowSidebar ? 'main-content' : ''}>
                {children}
            </div>

            {/* ChatBot Modal */}
            <Modal
                show={showChatBot}
                onHide={() => setShowChatBot(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <IoMdChatbubbles className="me-2" color="#3498db" />
                        Assistant E-Visa IA
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: 0, height: '500px' }}>
                    <ChatBot />
                </Modal.Body>
            </Modal>

            {/* Floating Chat Button */}
            <button
                className="floating-chat-button"
                onClick={handleChatBotOpen}
                title="Besoin d'aide ?"
            >
                <IoMdChatbubbles size={28} />
                <span className="chat-text">Besoin d'aide ?</span>
            </button>
        </>
    );
};

export default MainLayout;